import { useGlobal } from 'reactn';

import { hasSudoPermission } from './sudo';

/** Whether the signed-in user holds the `sudo` CBAC permission. Fails closed. */
const useSudoPermission = () => {
  const [global] = useGlobal();
  const { permissions, permissionIds } = global;

  return hasSudoPermission(permissions, permissionIds);
};

export default useSudoPermission;
